import AOS from 'aos'
import EmblaCarousel from 'embla-carousel'
import ClassNames from 'embla-carousel-class-names'
import Fade from 'embla-carousel-fade'
import Autoplay from 'embla-carousel-autoplay'
import { addPrevNextBtnsClickHandlers } from './modules/emblaArrows'
import { addDotBtnsAndClickHandlers } from './modules/EmblaDots'
//import { addScrollBarListener } from './modules/EmblaScrollBar'
import { setupProgressBar } from './modules/emblaProgress'

import {
  addThumbBtnsClickHandlers,
  addToggleThumbBtnsActive
} from './modules/EmblaThumbs'

AOS.init({
	duration: 900,
	once: true
});

// Set Viewport Width (vw) Variable
new ResizeObserver(function(){
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', vw + 'px');
  if(document.getElementById('alert-bar')) {
	 document.documentElement.style.setProperty('--alert-bar-height', document.getElementById('alert-bar').clientHeight + 'px');
  }
}).observe(document.documentElement);

// Sticky header
const headerEl = document.querySelector('#site-header');
const sentinelEl = document.querySelector('#header-sentinel');
const handler = (entries) => {
	if (!entries[0].isIntersecting) {
		headerEl.classList.add('sticky-header');
	} else {
		headerEl.classList.remove('sticky-header');
	}
}
const observer = new window.IntersectionObserver(handler);
observer.observe(sentinelEl);

if(window.innerWidth < 1200 && document.querySelector('.video-hero-band iframe')) {
	document.querySelector('.video-hero-band iframe').remove();
}

document.querySelectorAll(".link-to-anchor").forEach((el) => {
	el.addEventListener('click', function(e){
		e.preventDefault();
		let target = this.getAttribute("href");
		document.querySelector(target).scrollIntoView({behavior: 'smooth'});
	});
});

jQuery(function($){

	var keywordTimeout;

	$('.header-searchform .submit-btn').on('click', function(e){
		e.preventDefault();
		clearTimeout(keywordTimeout);
		let sf = $('.header-searchform');
		if(sf.hasClass('expanded')) {
			if(sf.find('.keyword').val()) {
				sf.find('form').submit();
			} else {
				sf.removeClass('expanded');
			}
		} else {
			sf.addClass('expanded');
			keywordTimeout = setTimeout(function(){
				sf.find('.keyword').focus();
			}, 100);

		}
	});

	$(window).click(function(e) {
		if( !$(e.target).parents('.main-menu').length ) {
			$('.header-searchform').removeClass('expanded');
		}
	});
	$('.header-searchform').click(function(event){
	  event.stopPropagation();
	});

	$('.audio-toggle').on('click', function(){
		let audio = $('#audio-bg')[0];

		if($(this).hasClass('played')) {
			audio.pause();
		} else {
			audio.play();
			if (typeof gtag === 'function') {
				gtag("event", "click", {
					"event_category": "music",
					"event_label": "play"
				});
			}
		}
		$(this).toggleClass('played');
	});

	// Accordion
	$('.expand-all-accordion').on('click', function(e){
		e.preventDefault();
		let $this = $(this);
		let accordionEl = $(this).closest('.theme-accordion');
		if($this.hasClass('expanded-all')) {
			accordionEl.find('.collapse').collapse('hide');
		} else {
			accordionEl.find('.collapse').collapse('show');
		}
		$this.toggleClass('expanded-all');
	});

	// Video Hero: Scroll to next section
	$('.video-hero-band .scroll-to-next').on('click', function(e){
		e.preventDefault();
		$('.video-hero-band').next()[0].scrollIntoView();
	});

	// Homepage Spotlight
	$('.play-spotlight-video').on('click', function(e){
		e.preventDefault();
		let vidFrame = $(this).siblings('iframe');
		let videoSrc = vidFrame.data('src');
		$(this).siblings('img').hide();
		vidFrame.attr('src', videoSrc).show();
		$(this).siblings('.award-icon').remove();
		$(this).remove();
	});


	// Projects Landing
	$('#projects-landing-wrapper').on('click', '.ajax-infinity-link-wrap a', function(e){
		e.preventDefault();
		let target = $(this).attr('href');
		let thisBtnWrap = $(this).closest('.ajax-infinity-link-wrap');

		let holderSelector = '#ajax-holder';
		let holder = $(holderSelector);

		thisBtnWrap.addClass('loading').append('<div class="loading-animation"><div></div></div>');

		$.get(target, function(response){
			thisBtnWrap.remove();
			let entries = $(response).find(holderSelector).children();
			holder.append(entries);
		});
	});

	$('.markets-filter').on('click', '.filter-link', function(e){
		e.preventDefault();
		let target = $(this).attr('href');
		let holder = $('#projects-landing-wrapper');
		let label = $(this).find('.btn-label').text();

		$('.markets-filter .filter-link').removeClass('active');
		$(this).addClass('active');
		if($(this).hasClass('reset-filter-link')) {
			$('.filter-toggle .btn-label').text($('.filter-toggle .btn-label').data('defaultlabel'));
		} else {
			$('.filter-toggle .btn-label').text(label);
		}

		$('.filter-toggle').removeClass('expanded');
		$('.filter-btns-list').slideUp(250);


		holder.addClass('loading').append('<div class="loading-animation"><div></div></div>');

		$.get(target, function(response){
			let entries = $(response).find('#projects-landing-wrapper').children();
			holder.removeClass('loading').html(entries);
			let heroContent = $(response).find('.hero-content').html();
			$('.hero-content').html(heroContent);
			window.history.replaceState('', '', target);
		});

	});

	// Mobile header
	$('.mobile-menu-toggle').on('click', function(e){
		e.preventDefault();
		e.stopPropagation();
		if( $('body').hasClass('mobile-menu-expanded') ){
			$('body').removeClass('mobile-menu-expanded');
			$('.main-menu').fadeOut(300);
			$('.header-searchform').removeClass('expanded');
		} else {
			$('body').addClass('mobile-menu-expanded');
			$('.main-menu').fadeIn(300);
			$('.header-searchform').addClass('expanded');
		}
	});
	$('.sub-nav-toggle').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('expanded').next('ul').slideToggle(200);
	});

	// Mobile filter dropdown
	$('.listing-filters-band .filter-toggle').on('click', function(e){
		e.preventDefault();
		$(this).toggleClass('expanded');
		$(this).next('.filter-btns-list').slideToggle(250);
	});

});

// Click infinity scroll trigger
document.addEventListener('aos:in:ist', (event) => {
	event.detail.querySelector('a').click();
});

// Slider: Client Quotes
const quotesSlider = document.querySelectorAll(".client-quotes");
quotesSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');
	const dotsNode = emblaNode.querySelector('.embla__dots');

	const OPTIONS = {
		loop: false,
		breakpoints: {
			'(min-width: 1200px)': { active: false },
		},
	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);

	const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
		emblaApi,
		dotsNode
	);

	emblaApi
		.on('destroy', removePrevNextBtnsClickHandlers)
		.on('destroy', removeDotBtnsAndClickHandlers);

});


// Slider: History
const historySlider = document.querySelectorAll(".history-slider");
historySlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');
	const slides = emblaNode.querySelectorAll('.embla__slide');

	const OPTIONS = {
		loop: false,
		align: 'start',
		containScroll: false,
		inViewThreshold: 0.9,
	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [ClassNames()]);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);
	emblaApi.on('destroy', removePrevNextBtnsClickHandlers);

	slides.forEach((slide, index) => {
		slide.addEventListener('click', () => {
			emblaApi.scrollTo(index);
		});
	});
});


// Slider: Project Media
const projectMediaSlider = document.querySelectorAll(".project-media-slider");
projectMediaSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');

	const OPTIONS = {
		loop: false,
		align: 'center',
		//containScroll: false,
	};

	if(viewportNode.querySelector('.embla__container').childElementCount > 2) {
		OPTIONS.loop = true;
	}

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [ClassNames()]);

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaApi,
	  prevBtnNode,
	  nextBtnNode
	);
	emblaApi.on('destroy', removePrevNextBtnsClickHandlers);

});


// Slider: Photo Collage
const collageSlider = document.querySelectorAll(".photo-collage-slider");
collageSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const pauseBtns = emblaNode.querySelectorAll('.pause-slider-btn');

	const OPTIONS = {
		loop: true,
		duration: 30,
		containScroll: false,
	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
		Fade(),
		Autoplay({ delay: 3500, stopOnInteraction: false }),
	]);

	const autoplay = emblaApi.plugins().autoplay;

	let isPlaying = true;

	pauseBtns.forEach((el) => {
		el.addEventListener('click', () => {
			if(isPlaying) {
				autoplay.stop();
				emblaNode.classList.add('paused');
			} else {
				autoplay.play();
				emblaNode.classList.remove('paused');
			}
			isPlaying = !isPlaying;
		});
	});


});


// Slider: Project Media
const fpSlider = document.querySelectorAll(".featured-projects-band");
fpSlider.forEach((emblaNode) => {
	const viewportNode = emblaNode.querySelector('.embla__viewport');
	const progressNode = emblaNode.querySelector('.embla__progress__bar');
	const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
	const nextBtnNode = emblaNode.querySelector('.embla__button--next');

	const OPTIONS = {
		loop: false,
		align: 'start',
		dragFree: true,
		inViewThreshold: 1,
	};

	const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [ClassNames()]);
	if(prevBtnNode && nextBtnNode) {
		const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
		  emblaApi,
		  prevBtnNode,
		  nextBtnNode
		);
	}

	const { applyProgress, removeProgress } = setupProgressBar(
	  emblaApi,
	  progressNode
	);

	emblaApi
	  .on('init', () => {emblaNode.querySelector('.embla-progress-outer').style.setProperty('--count-slides', emblaApi.slideNodes().length)})
	  .on('init', applyProgress)
	  .on('reInit', applyProgress)
	  .on('scroll', applyProgress)
	  .on('slideFocus', applyProgress)
	  .on('destroy', removeProgress);

});


// Slider: Team Photo
const tpSlider = document.querySelectorAll(".team-photo-slider");
tpSlider.forEach((emblaNode) => {
	const viewportNodeQuotes = emblaNode.querySelector('.team-photo-quote-slider .embla__viewport');
	const prevBtnNodeQuote = emblaNode.querySelector('.team-photo-quote-slider .embla__button--prev');
	const nextBtnNodeQuote = emblaNode.querySelector('.team-photo-quote-slider .embla__button--next');

	const viewportNodeImages = emblaNode.querySelector('.team-photo-image-slider .embla__viewport');
	const imageSlides = emblaNode.querySelectorAll('.team-photo-image-slider .embla__slide');



	const emblaQuoteApi = EmblaCarousel(viewportNodeQuotes, {
		loop: true,
		duration: 0,
	}, [Fade()]);

	const emblaImageApi = EmblaCarousel(viewportNodeImages, {
		loop: true,
		align: 'start',
		containScroll: false,
	});

	const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
	  emblaQuoteApi,
	  prevBtnNodeQuote,
	  nextBtnNodeQuote
	);

	const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
		emblaQuoteApi,
		emblaImageApi
	);
	const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
		emblaQuoteApi,
		emblaImageApi
	);

	emblaQuoteApi
		.on('destroy', removePrevNextBtnsClickHandlers)
		.on('destroy', removeThumbBtnsClickHandlers)
		.on('destroy', removeToggleThumbBtnsActive);

	emblaImageApi
		.on('destroy', removeThumbBtnsClickHandlers)
		.on('destroy', removeToggleThumbBtnsActive);


});
